<div class="container">
    <div>
        {{data}}
    </div>
    <div class="buttons">
        <button mat-flat-button  (click)="dismiss(true)">Yes</button>
        <button mat-raised-button (click)="dismiss(false)">No</button>
    </div>
</div>